import type { PortLayout, Point } from './toPortInfo.tsx';
import { midpoint } from './percentageOfLine.tsx';
import { move, line } from './lineLeft.tsx';

/** A straight route from start to end */
export const euclidean = (start: PortLayout, end: PortLayout) => ({
	path: move(start.position) + line(end.position),
	midpoint: midpoint(start.position, end.position),
});

export const GLOBAL_TRANSITION_ROUTE_HEIGHT_DISTANCE = 10;

/** Draws an L shape to the right then up */
export const globalTransitionRoute = (portPosition: Point, portOffset: number, width: number) =>
	`M${portPosition.x + portOffset},${portPosition.y}L${portPosition.x + width},${portPosition.y}L${
		portPosition.x + width
	},${portPosition.y - GLOBAL_TRANSITION_ROUTE_HEIGHT_DISTANCE}`;
